import { getExpiryBadgeMeta } from './pantryHelpers.js'

/**
 * Quiet expiry cue — text meta, not a colorful pill.
 * "Use soon" (≤2d) or "A few days" (3–5d). Window is days left, not calendar week.
 * @param {{ daysLeft?: number | null, size?: 'sm' | 'md', className?: string }} props
 */
export default function ExpiryBadge({ daysLeft, size = 'sm', className = '' }) {
  const meta = getExpiryBadgeMeta(daysLeft)
  if (!meta) return null
  return (
    <span
      className={[
        'pantry-expiry-badge',
        meta.tone === 'soon' ? 'pantry-expiry-badge--soon' : 'pantry-expiry-badge--later',
        size === 'md' ? 'pantry-expiry-badge--md' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {meta.label}
    </span>
  )
}
